import { render, staticRenderFns } from "./ThreeDRendersPage.vue?vue&type=template&id=6664f972&scoped=true"
import script from "./ThreeDRendersPage.vue?vue&type=script&lang=js"
export * from "./ThreeDRendersPage.vue?vue&type=script&lang=js"
import style0 from "./ThreeDRendersPage.vue?vue&type=style&index=0&id=6664f972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664f972",
  null
  
)

export default component.exports